module.exports = __webpack_public_path__ + "static/media/vc.21e12e80.svg";